(ns ductile.time.transit-handlers
  (:require [cognitect.transit :as transit])
  #?@(:cljs
      ((:require ["luxon" :refer [DateTime]]
                 [ductile.time.js-types :as types]))))

;; CLJ -> CLJS

#?(:clj
   (def write-handlers
     {java.time.LocalDate      (transit/write-handler "time/date" str)
      java.time.LocalTime      (transit/write-handler "time/time" str)
      java.time.LocalDateTime  (transit/write-handler "time/date-time" str) ;; this is the `time-literals` alias for local-date-time; I would prefer it to be more explicit but it is what it is
      java.time.ZonedDateTime  (transit/write-handler "time/offset-date-time" #(str (.toOffsetDateTime ^java.time.ZonedDateTime %)))
      java.time.OffsetDateTime (transit/write-handler "time/offset-date-time" str)
      java.time.Instant        (transit/write-handler "inst" str)
      java.net.URI             (transit/write-handler "uri" str)}))

#?(:cljs
   (def read-handlers
     {"time/date"             types/parse-local-date
      "time/time"             types/parse-local-time
      "time/date-time"        types/parse-local-date-time
      "time/offset-date-time" types/parse-offset-date-time
      "inst"                  types/parse-instant
      "uri"                   identity}))

;; CLJS -> CLJ

#?(:cljs
   (def write-handlers
     {ductile.time.js-types.LocalTime (transit/write-handler (fn [_] "time/time") types/format-iso)
      js/Date                         (transit/write-handler (fn [_] "inst") (fn [^js d] (.toISOString d)))
      DateTime                        (transit/write-handler (fn [_] "inst") (fn [^js d] (.toISO d)))}))

#?(:clj
   (def read-handlers
     {"time/time"             (transit/read-handler #(java.time.LocalTime/parse %))
      "time/date"             (transit/read-handler #(java.time.LocalDate/parse %))
      "time/date-time"        (transit/read-handler #(java.time.LocalDateTime/parse %))
      "time/offset-date-time" (transit/read-handler #(java.time.OffsetDateTime/parse %))
      "inst"                  (transit/read-handler #(java.time.Instant/parse %))}))
